import React, { useState, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { Link } from "gatsby"
import { useTranslation } from 'react-i18next'
import starIcon from './assets/star5.svg'
import WaveSection from '../../global/WaveSection'

const maxMobileWidth = 768;
const transformStep = typeof window !== "undefined" ? window.innerWidth : 0

const getCoverLink = ({type, id, imageUrl}) => {
  const baseUrl = 'https://storage.googleapis.com/audiodesires-aab7f.appspot.com'
  if(type === "audiobook") return `${baseUrl}/audiobooks/${id}/artwork/200/200.webp`
  const fileName = imageUrl.split('/').pop().split('.')[0]
  if(type === "story") return `${baseUrl}/stories/${id}/artwork/200/${fileName}.webp`
  if(type === "sleep") return `${baseUrl}/sleep/${id}/artwork/200/${fileName}.webp`
  if(type === "community") return `${baseUrl}/communityStories/${id}/artwork/200/${fileName}.webp`
}

const getUrl = ({type, t, slug}) => {
  if(type === "audiobook") return `${t('urls.audiobook')}${slug}/`
  if(type === "story") return `${t('urls.story')}${slug}/`
  if(type === "sleep") return `${t('urls.sleep')}${slug}/`
  if(type === "community") return `${t('urls.community-story')}${slug}/`
}


const testi = [
    {
      "text": "One of the best orgasms I ever had!",
    },
    {
      "text": "Love this story! Great sounds, amazing characters.",
    },
    {
      "text": "Super fun! Thank you for adding some spice back into my sexy time.",
    }
  ]

const Testimonials = (props) => {
  const { t } = useTranslation()
  const [transformValue, setTransformValue] = useState(0)
  const displayTestimonials = useMemo(() => {
    return props.testimonials ? props.testimonials : testi
  }, [props.testimonials])

  const selectedStories = useMemo(() => {
    return props.stories.sort(() => 0.5 - Math.random()).slice(0, 3)
  }, [props.stories])

  const hasMoreTestimonials = transformValue < transformStep * (displayTestimonials.length - 1)
  const handleNext = () => setTransformValue(prev => prev + transformStep)

  useEffect(() => {
    if(window.innerWidth < maxMobileWidth) return
    const interval = setInterval(() => {
      if(hasMoreTestimonials){
        handleNext()
      } else{
        setTransformValue(0)
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [hasMoreTestimonials]);

  return (
    <WaveSection>
      <Wrapper>
        <Slider style={{transform: `translateX(-${transformValue}px)`}}>
          {displayTestimonials.map((testimonial, index) => (
            <TestimonialWrapper key={`testimonial-${index}`}>
              <StarIcon src={starIcon} alt="5 star rating" />
              <TestimonialText>"{testimonial.text}"</TestimonialText>
              {selectedStories[index] && (
                <StoryInfoWrapper>
                  <Link to={getUrl({type:selectedStories[index].type, t, slug:selectedStories[index].slug})}>
                    <StoryCover  
                      alt={`${selectedStories[index].title} story cover`} 
                      src={getCoverLink({type:selectedStories[index].type, id:selectedStories[index].id, imageUrl:selectedStories[index].imageUrl})}
                    />
                  </Link>
                  <CustomerMeta>
                    <StoryName to={`${t('translations:urls.story')}${selectedStories[index].slug}`}>{selectedStories[index].title}</StoryName>
                    <StoryMeta>{`
                      ${selectedStories?.[index]?.voices[0]?.slug !== "placeholder" ? selectedStories?.[index]?.voices[0].name : ""}
                      ${selectedStories?.[index]?.voices.length > 1 ? ` + ${selectedStories?.[index]?.voices[1].name}  • ` : " •"}
                      ${selectedStories[index].type === "sleep" ? selectedStories[index].mainTag.tag : selectedStories[index].mainTag.fantasy}`
                    }</StoryMeta>
                  </CustomerMeta>
                </StoryInfoWrapper>
              )}
            </TestimonialWrapper>
          ))}
        </Slider>
      </Wrapper>
    </WaveSection>
  )
}

export default Testimonials

const Wrapper = styled.div`
  position: relative;
`;

const Slider = styled.div`
  overflow:visible;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100vw;
  margin: 20px 0;
  transition: transform 0.5s ease;
  @media (max-width: ${maxMobileWidth}px) {
    left: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    overflow-x: scroll;
    position: relative;
    right: 50%;
    -ms-scroll-snap-type: x mandatory;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
  }
`;

const StoryCover = styled.img`
  border-radius: 5px;
  width:75px;
  height:75px;
  margin-right:25px;
  @media ${props => props.theme.phonePort} {
    width:80px;
    height:80px;
  }
`

const TestimonialWrapper = styled.div`
  min-width: 100vw;
  margin-bottom: 20px;
  min-height: 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CustomerMeta = styled.div`
  display:flex;
  flex-direction: column;
  justify-content: center;
`

const StoryName = styled.h3`
  color:#272727;
  font-family:${props => props.theme.mainFontTitle};
  font-weight: 700;
  text-decoration:none;
  font-size: 16px;
  line-height: 2;
  margin: 0;
` 

const StoryMeta = styled.p`
  font-size:12px;
  margin: 0px 0px;
  text-transform:uppercase;
  font-family: ${props => props.theme.mainFontParagraph};
  color: #7a6664;
  font-weight:700;
  line-height: 12px;
`

const TestimonialText = styled.h2`
  max-width: 500px;
  color:#272727;
  text-align:center;
  font-size:1.5rem;
  margin:20px 0 30px 0;
  @media ${props => props.theme.phonePort} {
    max-width: 90%;
    font-size:1.3rem;
  }
`

const StoryInfoWrapper = styled.div`
  display:flex;
  flex-direction: row;
  justify-content: center;
`

const StarIcon = styled.img`
  width: 200px;
  height: 20px;
  margin: 2px;
`